import React from 'react';
import { Route, Switch, Redirect } from 'react-router';

import useBrand from '@webtv/hooks/use-brand';

const Login = React.lazy(() => import(/* webpackChunkName: "login" */ '@webtv/pages/login'));

const ActivateAccount = React.lazy(
  () => import(/* webpackChunkName: "activate-user" */ '@webtv/pages/activate-account')
);

const SendActivationEmail = React.lazy(
  () => import(/* webpackChunkName: "send-activation-email" */ '@webtv/pages/send-activation-email')
);

const ChangePassword = React.lazy(
  () => import(/* webpackChunkName: "change-password" */ '@webtv/pages/change-password')
);

export const UnauthenticatedRoutes: React.FC = () => {
  const { isNorlys } = useBrand();

  return (
    <React.Suspense fallback={null}>
      <Switch>
        {isNorlys && (
          <Route path="/aktiver-bruger/:token">
            <ActivateAccount />
          </Route>
        )}

        {isNorlys && (
          <Route path="/send-aktiverings-email">
            <SendActivationEmail />
          </Route>
        )}

        {isNorlys && (
          <Route path="/skift-kodeord/:token">
            <ChangePassword />
          </Route>
        )}

        <Route path="/login">
          <Login />
        </Route>

        <Route path="*" render={() => <Redirect to="/login" />} />
      </Switch>
    </React.Suspense>
  );
};

export default UnauthenticatedRoutes;
